import React, { Component } from 'react';
import CloudZenythApp from './components/general/AdminSoftApp'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './assets/css/main.scss';

// Crear un cliente para React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Evita recargar datos al cambiar de pestaña (puedes activarlo si quieres)
      retry: 1, // Reintenta una vez si la petición falla
      staleTime: 5 * 60 * 1000, // Los datos se consideran "frescos" por 5 minutos
    },
  },
});

class CloudZenyth extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <CloudZenythApp />
        </div>
        {/* Herramienta de desarrollo para ver la caché en tiempo real (solo en desarrollo) */}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    );
  }
}

export default CloudZenyth;